module.exports = __webpack_public_path__ + "static/media/slider-15.787a638c.jpg";